import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { LinearProgress } from '@mui/material';
import Notifications from 'components/Notifications';
import { Outlet } from 'react-router-dom';

const Restaurant = props => {

  return (
    <div className="h-full w-full flex flex-col overflow-hidden">
      <div className="flex flex-1 overflow-hidden">
        <main className="overflow-y-auto flex-1">
          <Suspense fallback={<LinearProgress />}>
            <Outlet />
          </Suspense>
        </main>
      </div>
      <Notifications />
    </div>
  );
};

Restaurant.propTypes = {
  route: PropTypes.object
};

export default Restaurant;
